import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import debounce from 'lodash/debounce';
import dataService from 'services/dataService';
import List from 'components/atoms/list';
import useOutsideClick from 'utils/useOutsideClick';
import ResetSearchIcon from 'components/atoms/icons/searchResetIcon';
import { API_PATIENT_ICD__CODES } from 'services/dataService/ccmResources';

const loadingOptions = [{ id: 'loading', label: 'Loading...' }];
let timer;

const ICDCodeAutocomplete = ({ filter, handleClick, showLabel, inputRef }) => {
  const [query, setQuery] = useState('');
  if (inputRef) inputRef.current = { setValue: setQuery };
  const containerRef = useRef();
  const [show, setShow] = useState(false);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useOutsideClick(containerRef, () => {
    setShow(false);
  });

  const debouncedSearch = debounce(async (string) => {
    const { data } = await dataService.getList(
      `${API_PATIENT_ICD__CODES}?code=${string}`,
    );
    setIsLoading(false);
    if (data) {
      setOptions(
        data.items.map((item) => ({
          id: item.guid,
          value: item.guid,
          label: item.code,
          description: item.description,
        })),
      );
    }
  }, 800);

  const handleInputChange = (string) => {
    if (string.target) {
      setQuery(string.target.value);
    }
    setIsLoading(true);
    clearTimeout(timer);
    timer = setTimeout(() => {
      debouncedSearch(string.target ? string.target.value : query);
    }, 500);
  };

  const handleOptionClick = (option) => {
    setQuery(option.label);
    handleInputChange(option.label);
    setShow(true);
    return handleClick(option);
  };

  const handleFocus = () => {
    if (filter.id === 'code') {
      setShow(true);
    }
  };

  //   const autoCompleteClass = () => {
  //     let className = 'card-border';
  //     if (showLabel) {
  //       className = 'card-border card-shadow border-0';
  //     }
  //     return className;
  //   };

  const resetSearch = () => {
    setQuery('');
    handleInputChange('');
    debouncedSearch('');
    handleClick({ value: '' });
  };

  return (
    <div className="autocomplete autocomplete--table-input" ref={containerRef}>
      <div className="dropdown" role="button" aria-hidden>
        <Card>
          <CardBody>
            {showLabel && <p>{filter.label}</p>}
            <div className="autocomplete__input-container">
              <input
                className="autocomplete__input"
                placeholder={filter.placeholder}
                type="text"
                onChange={handleInputChange}
                value={query}
                onFocus={handleFocus}
              />
              {query !== '' && <ResetSearchIcon onClick={resetSearch} />}
            </div>
          </CardBody>
        </Card>
      </div>
      {isLoading && show && (
        <div className="autocomplete__list">
          <List onChange={() => {}} options={loadingOptions} />
        </div>
      )}
      {!isLoading && options && options.length > 0 && show && (
        <div className="autocomplete__list">
          <List onChange={handleOptionClick} options={options} />
        </div>
      )}
    </div>
  );
};

ICDCodeAutocomplete.propTypes = {
  filter: PropTypes.shape().isRequired,
  inputRef: PropTypes.shape(),
  handleClick: PropTypes.func.isRequired,
  showLabel: PropTypes.bool,
};

export default ICDCodeAutocomplete;
